import {
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_SUCCESS,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_FAILURE,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_SUCCESS,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_FAILURE,
  SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT,
  SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS,
  DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE,
  GET_BOM_COMPONENT_LIST,
  GET_BOM_COMPONENT_LIST_SUCCESS,
  GET_BOM_COMPONENT_LIST_FAILURE,
  GET_BOM_COMPONENT_DATA,
  GET_BOM_COMPONENT_DATA_SUCCESS,
  GET_BOM_COMPONENT_DATA_FAILURE,
  SEARCH_BOM_COMPONENT,
  SEARCH_BOM_COMPONENT_SUCCESS,
  SEARCH_BOM_COMPONENT_FAILURE,
  CREATE_BOM_COMPONENT,
  CREATE_BOM_COMPONENT_SUCCESS,
  CREATE_BOM_COMPONENT_FAILURE,
  UPDATE_BOM_COMPONENT,
  UPDATE_BOM_COMPONENT_SUCCESS,
  UPDATE_BOM_COMPONENT_FAILURE,
  DELETE_BOM_COMPONENT,
  DELETE_BOM_COMPONENT_SUCCESS,
  DELETE_BOM_COMPONENT_FAILURE,
  GET_SALES_ORDER_BILL_OF_MATERIALS,
  GET_SALES_ORDER_BILL_OF_MATERIALS_SUCCESS,
  GET_SALES_ORDER_BILL_OF_MATERIALS_FAILURE,
  GET_BOM_LIST,
  GET_BOM_LIST_SUCCESS,
  GET_BOM_LIST_FAILURE,
  GET_BOM_DATA,
  GET_BOM_DATA_SUCCESS,
  GET_BOM_DATA_FAILURE,
  SEARCH_BOM,
  SEARCH_BOM_SUCCESS,
  SEARCH_BOM_FAILURE,
  CREATE_BOM,
  CREATE_BOM_SUCCESS,
  CREATE_BOM_FAILURE,
  UPDATE_BOM,
  UPDATE_BOM_SUCCESS,
  UPDATE_BOM_FAILURE,
  DELETE_BOM,
  DELETE_BOM_SUCCESS,
  DELETE_BOM_FAILURE,
  CREATE_BOM_VERSION,
  CREATE_BOM_VERSION_SUCCESS,
  CREATE_BOM_VERSION_FAILURE,
  CLONE_BOM,
  CLONE_BOM_SUCCESS,
  CLONE_BOM_FAILURE,
  SEARCH_PRODUCT_TO_BOM,
  SEARCH_PRODUCT_TO_BOM_SUCCESS,
  SEARCH_PRODUCT_TO_BOM_FAILURE,
  SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE,
  SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_SUCCESS,
  SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_FAILURE,
} from "./actionType";

const initialState = {
  //GET_SALES_ORDER_BILL_OF_MATERIALS
  salesOrderBillOfMaterials: null,
  salesOrderBillOfMaterialsLoading: false,
  salesOrderBillOfMaterialsError: null,
  //GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST
  bomComponentSupplierProductList: [],
  bomComponentSupplierProductListLoading: false,
  bomComponentSupplierProductListError: null,
  //GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA
  bomComponentSupplierProductData: null,
  bomComponentSupplierProductDataLoading: false,
  bomComponentSupplierProductDataError: null,
  //SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT
  bomComponentSupplierProductSearchResults: [],
  bomComponentSupplierProductSearchLoading: false,
  bomComponentSupplierProductSearchError: null,
  //CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT
  bomComponentSupplierProductCreate: null,
  bomComponentSupplierProductCreateLoading: false,
  bomComponentSupplierProductCreateError: null,
  //UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT
  bomComponentSupplierProductUpdate: null,
  bomComponentSupplierProductUpdateLoading: false,
  bomComponentSupplierProductUpdateError: null,
  //DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT
  bomComponentSupplierProductDelete: null,
  bomComponentSupplierProductDeleteLoading: false,
  bomComponentSupplierProductDeleteError: null,
  //GET_BOM_COMPONENT_LIST
  bomComponentList: [],
  bomComponentListLoading: false,
  bomComponentListError: null,
  //GET_BOM_COMPONENT_DATA
  bomComponentData: null,
  bomComponentDataLoading: false,
  bomComponentDataError: null,
  //SEARCH_BOM_COMPONENT
  bomComponentSearchResults: [],
  bomComponentSearchLoading: false,
  bomComponentSearchError: null,
  //CREATE_BOM_COMPONENT
  bomComponentCreate: null,
  bomComponentCreateLoading: false,
  bomComponentCreateError: null,
  //UPDATE_BOM_COMPONENT
  bomComponentUpdate: null,
  bomComponentUpdateLoading: false,
  bomComponentUpdateError: null,
  //DELETE_BOM_COMPONENT
  bomComponentDelete: null,
  bomComponentDeleteLoading: false,
  bomComponentDeleteError: null,
  //GET_BOM_LIST
  bomList: [],
  bomListLoading: false,
  bomListError: null,
  //GET_BOM_DATA
  bomData: null,
  bomDataLoading: false,
  bomDataError: null,
  //SEARCH_BOM
  bomSearchResults: [],
  bomSearchLoading: false,
  bomSearchError: null,
  //CREATE_BOM
  bomCreate: null,
  bomCreateLoading: false,
  bomCreateError: null,
  //UPDATE_BOM
  bomUpdate: null,
  bomUpdateLoading: false,
  bomUpdateError: null,
  //DELETE_BOM
  bomDelete: null,
  bomDeleteLoading: false,
  bomDeleteError: null,
  //CREATE_BOM_VERSION
  bomVersionCreate: null,
  bomVersionCreateLoading: false,
  bomVersionCreateError: null,
  //CLONE_BOM
  bomClone: null,
  bomCloneLoading: false,
  bomCloneError: null,
  //SEARCH_PRODUCT_TO_BOM
  productToBomSearchResults: [],
  productToBomSearchLoading: false,
  productToBomSearchError: null,
  //SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE
  productBomToProductRuleSearch: null,
  productBomToProductRuleSearchLoading: false,
  productBomToProductRuleSearchError: null,
};

const bomReducer = (state = initialState, action) => {
  switch (action.type) {
    //GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST
    case GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST:
      return {
        ...state,
        bomComponentSupplierProductListLoading: true,
        bomComponentSupplierProductListError: null,
      };
    case GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        bomComponentSupplierProductList: action.payload,
        bomComponentSupplierProductListLoading: false,
      };
    case GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        bomComponentSupplierProductListLoading: false,
        bomComponentSupplierProductListError: action.error,
      };
    //GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA
    case GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA:
      return {
        ...state,
        bomComponentSupplierProductDataLoading: true,
        bomComponentSupplierProductDataError: null,
      };
    case GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_SUCCESS:
      return {
        ...state,
        bomComponentSupplierProductData: action.payload,
        bomComponentSupplierProductDataLoading: false,
      };
    case GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_FAILURE:
      return {
        ...state,
        bomComponentSupplierProductDataLoading: false,
        bomComponentSupplierProductDataError: action.error,
      };
    //SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT
    case SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT:
      return {
        ...state,
        bomComponentSupplierProductSearchLoading: true,
        bomComponentSupplierProductSearchError: null,
      };
    case SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS:
      return {
        ...state,
        bomComponentSupplierProductSearchResults: action.payload,
        bomComponentSupplierProductSearchLoading: false,
      };
    case SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE:
      return {
        ...state,
        bomComponentSupplierProductSearchLoading: false,
        bomComponentSupplierProductSearchError: action.error,
      };
    //CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT
    case CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT:
      return {
        ...state,
        bomComponentSupplierProductCreateLoading: true,
        bomComponentSupplierProductCreateError: null,
      };
    case CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS:
      return {
        ...state,
        bomComponentSupplierProductCreate: action.payload,
        bomComponentSupplierProductCreateLoading: false,
      };
    case CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE:
      return {
        ...state,
        bomComponentSupplierProductCreateLoading: false,
        bomComponentSupplierProductCreateError: action.error,
      };
    //UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT
    case UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT:
      return {
        ...state,
        bomComponentSupplierProductUpdateLoading: true,
        bomComponentSupplierProductUpdateError: null,
      };
    case UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS:
      return {
        ...state,
        bomComponentSupplierProductUpdate: action.payload,
        bomComponentSupplierProductUpdateLoading: false,
      };
    case UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE:
      return {
        ...state,
        bomComponentSupplierProductUpdateLoading: false,
        bomComponentSupplierProductUpdateError: action.error,
      };
    //DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT
    case DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT:
      return {
        ...state,
        bomComponentSupplierProductDeleteLoading: true,
        bomComponentSupplierProductDeleteError: null,
      };
    case DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS:
      return {
        ...state,
        bomComponentSupplierProductDelete: action.payload,
        bomComponentSupplierProductDeleteLoading: false,
      };
    case DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE:
      return {
        ...state,
        bomComponentSupplierProductDeleteLoading: false,
        bomComponentSupplierProductDeleteError: action.error,
      };
    //GET_BOM_COMPONENT_LIST
    case GET_BOM_COMPONENT_LIST:
      return {
        ...state,
        bomComponentListLoading: true,
        bomComponentListError: null,
      };
    case GET_BOM_COMPONENT_LIST_SUCCESS:
      return {
        ...state,
        bomComponentList: action.payload,
        bomComponentListLoading: false,
      };
    case GET_BOM_COMPONENT_LIST_FAILURE:
      return {
        ...state,
        bomComponentListLoading: false,
        bomComponentListError: action.error,
      };
    //GET_BOM_COMPONENT_DATA
    case GET_BOM_COMPONENT_DATA:
      return {
        ...state,
        bomComponentDataLoading: true,
        bomComponentDataError: null,
      };
    case GET_BOM_COMPONENT_DATA_SUCCESS:
      return {
        ...state,
        bomComponentData: action.payload,
        bomComponentDataLoading: false,
      };
    case GET_BOM_COMPONENT_DATA_FAILURE:
      return {
        ...state,
        bomComponentDataLoading: false,
        bomComponentDataError: action.error,
      };
    //SEARCH_BOM_COMPONENT
    case SEARCH_BOM_COMPONENT:
      return {
        ...state,
        bomComponentSearchLoading: true,
        bomComponentSearchError: null,
      };
    case SEARCH_BOM_COMPONENT_SUCCESS:
      return {
        ...state,
        bomComponentSearchResults: action.payload,
        bomComponentSearchLoading: false,
      };
    case SEARCH_BOM_COMPONENT_FAILURE:
      return {
        ...state,
        bomComponentSearchLoading: false,
        bomComponentSearchError: action.error,
      };
    //CREATE_BOM_COMPONENT
    case CREATE_BOM_COMPONENT:
      return {
        ...state,
        bomComponentCreateLoading: true,
        bomComponentCreateError: null,
      };
    case CREATE_BOM_COMPONENT_SUCCESS:
      return {
        ...state,
        bomComponentCreate: action.payload,
        bomComponentCreateLoading: false,
      };
    case CREATE_BOM_COMPONENT_FAILURE:
      return {
        ...state,
        bomComponentCreateLoading: false,
        bomComponentCreateError: action.error,
      };
    //UPDATE_BOM_COMPONENT
    case UPDATE_BOM_COMPONENT:
      return {
        ...state,
        bomComponentUpdateLoading: true,
        bomComponentUpdateError: null,
      };
    case UPDATE_BOM_COMPONENT_SUCCESS:
      return {
        ...state,
        bomComponentUpdate: action.payload,
        bomComponentUpdateLoading: false,
      };
    case UPDATE_BOM_COMPONENT_FAILURE:
      return {
        ...state,
        bomComponentUpdateLoading: false,
        bomComponentUpdateError: action.error,
      };
    //DELETE_BOM_COMPONENT
    case DELETE_BOM_COMPONENT:
      return {
        ...state,
        bomComponentDeleteLoading: true,
        bomComponentDeleteError: null,
      };
    case DELETE_BOM_COMPONENT_SUCCESS:
      return {
        ...state,
        bomComponentDelete: action.payload,
        bomComponentDeleteLoading: false,
      };
    case DELETE_BOM_COMPONENT_FAILURE:
      return {
        ...state,
        bomComponentDeleteLoading: false,
        bomComponentDeleteError: action.error,
      };
    //GET_BOM_LIST
    case GET_BOM_LIST:
      return {
        ...state,
        bomListLoading: true,
        bomListError: null,
      };
    case GET_BOM_LIST_SUCCESS:
      return {
        ...state,
        bomList: action.payload,
        bomListLoading: false,
      };
    case GET_BOM_LIST_FAILURE:
      return {
        ...state,
        bomListLoading: false,
        bomListError: action.error,
      };
    //GET_SALES_ORDER_BILL_OF_MATERIALS
    case GET_SALES_ORDER_BILL_OF_MATERIALS:
      return {
        ...state,
        salesOrderBillOfMaterialsLoading: true,
        salesOrderBillOfMaterialsError: null,
      };
    case GET_SALES_ORDER_BILL_OF_MATERIALS_SUCCESS:
      return {
        ...state,
        salesOrderBillOfMaterials: action.payload,
        salesOrderBillOfMaterialsLoading: false,
      };
    case GET_SALES_ORDER_BILL_OF_MATERIALS_FAILURE:
      return {
        ...state,
        salesOrderBillOfMaterialsLoading: false,
        salesOrderBillOfMaterialsError: action.error,
      };
    //GET_BOM_DATA
    case GET_BOM_DATA:
      return {
        ...state,
        bomDataLoading: true,
        bomDataError: null,
      };
    case GET_BOM_DATA_SUCCESS:
      return {
        ...state,
        bomData: action.payload,
        bomDataLoading: false,
      };
    case GET_BOM_DATA_FAILURE:
      return {
        ...state,
        bomDataLoading: false,
        bomDataError: action.error,
      };
    //SEARCH_BOM
    case SEARCH_BOM:
      return {
        ...state,
        bomSearchLoading: true,
        bomSearchError: null,
      };
    case SEARCH_BOM_SUCCESS:
      return {
        ...state,
        bomSearchResults: action.payload,
        bomSearchLoading: false,
      };
    case SEARCH_BOM_FAILURE:
      return {
        ...state,
        bomSearchLoading: false,
        bomSearchError: action.error,
      };
    //CREATE_BOM
    case CREATE_BOM:
      return {
        ...state,
        bomCreateLoading: true,
        bomCreateError: null,
      };
    case CREATE_BOM_SUCCESS:
      return {
        ...state,
        bomCreate: action.payload,
        bomCreateLoading: false,
      };
    case CREATE_BOM_FAILURE:
      return {
        ...state,
        bomCreateLoading: false,
        bomCreateError: action.error,
      };
    //UPDATE_BOM
    case UPDATE_BOM:
      return {
        ...state,
        bomUpdateLoading: true,
        bomUpdateError: null,
      };
    case UPDATE_BOM_SUCCESS:
      return {
        ...state,
        bomUpdate: action.payload,
        bomUpdateLoading: false,
      };
    case UPDATE_BOM_FAILURE:
      return {
        ...state,
        bomUpdateLoading: false,
        bomUpdateError: action.error,
      };
    //DELETE_BOM
    case DELETE_BOM:
      return {
        ...state,
        bomDeleteLoading: true,
        bomDeleteError: null,
      };
    case DELETE_BOM_SUCCESS:
      return {
        ...state,
        bomDelete: action.payload,
        bomDeleteLoading: false,
      };
    case DELETE_BOM_FAILURE:
      return {
        ...state,
        bomDeleteLoading: false,
        bomDeleteError: action.error,
      };
    //CREATE_BOM_VERSION
    case CREATE_BOM_VERSION:
      return {
        ...state,
        bomVersionCreateLoading: true,
        bomVersionCreateError: null,
      };
    case CREATE_BOM_VERSION_SUCCESS:
      return {
        ...state,
        bomVersionCreate: action.payload,
        bomVersionCreateLoading: false,
      };
    case CREATE_BOM_VERSION_FAILURE:
      return {
        ...state,
        bomVersionCreateLoading: false,
        bomVersionCreateError: action.error,
      };
    //CLONE_BOM
    case CLONE_BOM:
      return {
        ...state,
        bomCloneLoading: true,
        bomCloneError: null,
      };
    case CLONE_BOM_SUCCESS:
      return {
        ...state,
        bomClone: action.payload,
        bomCloneLoading: false,
      };
    case CLONE_BOM_FAILURE:
      return {
        ...state,
        bomCloneLoading: false,
        bomCloneError: action.error,
      };
    //SEARCH_PRODUCT_TO_BOM
    case SEARCH_PRODUCT_TO_BOM:
      return {
        ...state,
        productToBomSearchLoading: true,
        productToBomSearchError: null,
      };
    case SEARCH_PRODUCT_TO_BOM_SUCCESS:
      return {
        ...state,
        productToBomSearchResults: action.payload,
        productToBomSearchLoading: false,
      };
    case SEARCH_PRODUCT_TO_BOM_FAILURE:
      return {
        ...state,
        productToBomSearchLoading: false,
        productToBomSearchError: action.error,
      };
    //SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE
    case SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE:
      return {
        ...state,
        productBomToProductRuleSearchLoading: true,
        productBomToProductRuleSearchError: null,
      };
    case SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_SUCCESS:
      return {
        ...state,
        productBomToProductRuleSearch: action.payload,
        productBomToProductRuleSearchLoading: false,
      };
    case SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_FAILURE:
      return {
        ...state,
        productBomToProductRuleSearchLoading: false,
        productBomToProductRuleSearchError: action.error,
      };
    default:
      return state;
  }
};
export default bomReducer;
